/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const MailIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M22.5,17 C22.5,17.828 21.828,18.5 21,18.5 L3,18.5 C2.172,18.5 1.5,17.828 1.5,17 L1.5,6 C1.5,5.171 2.172,4.5 3,4.5 L21,4.5 C21.828,4.5 22.5,5.171 22.5,6 L22.5,17 Z" />
      <polyline points="22 5 12 13 2 5" />
    </g>
  </svg>
);

export default MailIcon;
